import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Supported languages (must match /translations folder)
const supportedLanguages = ["en", "es", "fr", "zh", "ar", "pt"];
const fallbackLng = "en";

async function loadLanguage(langCode) {
  const finalLang = supportedLanguages.includes(langCode) ? langCode : fallbackLng;

  try {
    const module = await import(`./translations/${finalLang}.js`);
    const resources = module.default || module[finalLang];

    i18n
      .use(initReactI18next)
      .init({
        resources: {
          [finalLang]: { translation: resources },
        },
        lng: finalLang,
        fallbackLng,
        interpolation: { escapeValue: false },
      });

    console.log(`✅ Language ${finalLang} loaded successfully.`);
  } catch (error) {
    console.error(`❌ Failed to load language file for ${finalLang}:`, error);
  }
}

export { loadLanguage };
